// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Json_decode from "../../../../../../../node_modules/@glennsl/bs-json/src/Json_decode.mjs";

function pathDecoder(json) {
  return {
          page_path: Json_decode.at({
                  hd: "attributes",
                  tl: {
                    hd: "page_path",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json),
          city_label: Json_decode.at({
                  hd: "attributes",
                  tl: {
                    hd: "city_label",
                    tl: /* [] */0
                  }
                }, Json_decode.string)(json)
        };
}

function execute(json) {
  return $$Array.of_list(Json_decode.at({
                    hd: "data",
                    tl: /* [] */0
                  }, (function (param) {
                      return Json_decode.list(pathDecoder, param);
                    }))(json));
}

export {
  pathDecoder ,
  execute ,
}
/* No side effect */
